import isEmpty from 'lodash-es/isEmpty';

import { isNullOrUndefined } from '@app/util/util';

export function encodeURIParams(str: string): string {
  return !isNullOrUndefined(str) && !isEmpty(str) ? btoa(unescape(encodeURI(str))) : '';
}

export function decodeURIParams(str: string): string {
  return !isNullOrUndefined(str) && !isEmpty(str) ? decodeURIComponent(escape(atob(str))) : null;
}
